export default {
  placement: 'QUOTES',
  chatInteractionId: 62858
}
